import { createStyles, makeStyles } from '@material-ui/styles'
import { Theme } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      fontSize: '0.85rem',
      '& > *': {
        marginBottom: '.5rem'
      }
    },
    unsubscribeWrapper: {
      marginTop: '1rem'
    },
    unsubscribeTexte: {
      marginTop: '.5rem',
      color: '#a0a0a0'
    },
    unsubscribeLink: {
      color: '#404040',
      marginLeft: '.3rem',
      fontWeight: 'bold',
      cursor: 'pointer',
      textDecoration: 'underline'
    },
    action: {
      '& > *:nth-child(2n)': {},
      '& > *:nth-child(2n+1)': {
        marginRight: '.5rem'
      }
    },
    subscribeButtom: {
      [theme.breakpoints.down('md')]: {
        width: '100%',
        marginTop: '.5rem',
        marginBottom: '.5rem'
      }
    }
  })
)
